(function () {
  var GLYPHS = '01#/\\<>_=+~*%&$@[]|';
  function noise() { return GLYPHS.charAt(Math.floor(Math.random() * GLYPHS.length)); }
  var peakCache = {}, actx = null, currentCard = null;

  function fmt(t) {
    if (!isFinite(t) || t < 0) t = 0;
    var m = Math.floor(t / 60), s = Math.floor(t % 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  }
  function hash(str) { var h = 2166136261, i; for (i = 0; i < str.length; i++) h = Math.imul(h ^ str.charCodeAt(i), 16777619); return h >>> 0; }
  function rng(seed) {
    return function () {
      seed |= 0; seed = (seed + 0x6D2B79F5) | 0;
      var t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }
  function decodePeaks(src, n) {
    if (peakCache[src]) return peakCache[src];
    var AC = window.AudioContext || window.webkitAudioContext;
    peakCache[src] = new Promise(function (resolve) {
      if (!AC || !window.fetch) return resolve(null);
      fetch(src).then(function (r) { return r.arrayBuffer(); }).then(function (buf) {
        actx = actx || new AC();
        return new Promise(function (ok, no) { actx.decodeAudioData(buf, ok, no); });
      }).then(function (ab) {
        var d = ab.getChannelData(0), step = Math.floor(d.length / n) || 1, out = [], max = 0, i, j;
        for (i = 0; i < n; i++) {
          var peak = 0;
          for (j = 0; j < step; j += 16) { var v = Math.abs(d[i * step + j] || 0); if (v > peak) peak = v; }
          out.push(peak); if (peak > max) max = peak;
        }
        resolve(out.map(function (p) { return max ? p / max : 0; }));
      }).catch(function () { resolve(null); });
    });
    return peakCache[src];
  }

  function initCard(root, card) {
    var dry = (card.dataset.dry || '').trim(), wet = (card.dataset.wet || '').trim();
    var btn = card.querySelector('[data-ba-play]'), canvas = card.querySelector('[data-ba-wave]');
    var timeEl = card.querySelector('[data-ba-time]'), statusEl = card.querySelector('[data-ba-status]');
    var vbtns = [].slice.call(card.querySelectorAll('[data-ba-ver]'));
    var ctx = canvas.getContext('2d');
    var src = { dry: dry, wet: wet };
    var ver = dry ? 'dry' : (wet ? 'wet' : '');
    var A = {}, peaks = {}, asked = {}, want = false, raf = 0, loaded = false, colors = null;
    var r = rng(hash(dry + wet + (card.querySelector('.ba__title') || {}).textContent));
    var pseudo = [], k, ph = r() * 6;
    for (k = 0; k < 240; k++) pseudo.push(0.18 + 0.82 * Math.abs(Math.sin(k * 0.11 + ph) * 0.55 + Math.sin(k * 0.043 + ph * 2) * 0.45) * (0.55 + 0.45 * r()));

    function label() {
      if (!ver) return root.dataset.emptyText;
      return 'Now: <b>' + (ver === 'dry' ? root.dataset.dryStatus : root.dataset.wetStatus) + '</b>';
    }
    function paintStatus() { statusEl.innerHTML = label(); }
    function lead() { return ver ? A[ver] : null; }
    function palette() {
      if (colors) return colors;
      var cs = getComputedStyle(card);
      colors = { idle: cs.getPropertyValue('--ba-wave').trim() || '#444', on: cs.getPropertyValue('--ba-on').trim() || '#d60f19' };
      return colors;
    }
    function draw() {
      var w = canvas.clientWidth, h = canvas.clientHeight, dpr = window.devicePixelRatio || 1;
      if (!w || !h) return;
      if (canvas.width !== Math.round(w * dpr)) { canvas.width = Math.round(w * dpr); canvas.height = Math.round(h * dpr); }
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, w, h);
      var a = lead(), c = palette(), pk = (ver && peaks[ver]) || pseudo;
      var bw = 2, gap = 2, n = Math.floor(w / (bw + gap)), prog = a && a.duration ? a.currentTime / a.duration : 0, i;
      for (i = 0; i < n; i++) {
        var p = pk[Math.min(pk.length - 1, Math.floor(i / n * pk.length))];
        var bh = Math.max(2, p * (h - 4));
        ctx.fillStyle = (i / n) < prog && ver ? c.on : c.idle;
        ctx.fillRect(i * (bw + gap), (h - bh) / 2, bw, bh);
      }
      timeEl.textContent = a ? fmt(a.currentTime) + ' / ' + fmt(a.duration) : '0:00 / 0:00';
    }
    function loadPeaks(v) {
      if (!src[v] || asked[v]) return;
      asked[v] = true;
      decodePeaks(src[v], 240).then(function (p) { if (p) { peaks[v] = p; draw(); } });
    }
    function ensure() {
      if (loaded) return;
      loaded = true;
      ['dry', 'wet'].forEach(function (v) {
        if (!src[v]) return;
        var a = new Audio();
        a.preload = 'auto';
        a.src = src[v];
        a.muted = v !== ver;
        a.addEventListener('ended', function () { if (A[ver] === a) stopAll(true); });
        a.addEventListener('error', function () { if (A[ver] === a) { want = false; setPlaying(false); statusEl.textContent = 'Source unavailable'; } });
        a.addEventListener('loadedmetadata', draw);
        A[v] = a;
      });
    }
    function others() { return Object.keys(A).filter(function (v) { return v !== ver; }).map(function (v) { return A[v]; }); }
    function setPlaying(on) {
      card.classList.toggle('is-playing', on);
      card.classList.toggle('is-active', on || (lead() && lead().currentTime > 0));
      btn.setAttribute('aria-label', (on ? 'Pause ' : 'Play ') + (card.dataset.name || ''));
      if (on) { cancelAnimationFrame(raf); raf = requestAnimationFrame(loop); }
    }
    function loop() {
      var a = lead();
      if (a) others().forEach(function (o) { if (Math.abs(o.currentTime - a.currentTime) > 0.1) { try { o.currentTime = a.currentTime; } catch (e) {} } });
      draw();
      if (want) raf = requestAnimationFrame(loop);
    }
    function stopAll(reset) {
      want = false;
      Object.keys(A).forEach(function (v) { A[v].pause(); if (reset) { try { A[v].currentTime = 0; } catch (e) {} } });
      setPlaying(false);
      if (reset) card.classList.remove('is-active');
      draw();
    }
    function play() {
      if (!ver) return;
      if (currentCard && currentCard !== api) currentCard.pause();
      currentCard = api;
      ensure();
      loadPeaks(ver);
      want = true;
      var a = lead();
      Object.keys(A).forEach(function (v) { A[v].muted = v !== ver; });
      Object.keys(A).forEach(function (v) {
        if (A[v] !== a) { try { A[v].currentTime = a.currentTime; } catch (e) {} }
        var pr = A[v].play(); if (pr && pr.catch) pr.catch(function () { if (A[ver] === A[v]) { want = false; setPlaying(false); } });
      });
      setPlaying(true);
    }
    function pause() { want = false; Object.keys(A).forEach(function (v) { A[v].pause(); }); setPlaying(false); draw(); }
    var api = { pause: pause };

    function setVer(v) {
      if (!src[v] || v === ver) return;
      var prev = lead();
      ver = v;
      var a = lead();
      if (a && prev) {
        if (Math.abs(a.currentTime - prev.currentTime) > 0.05) { try { a.currentTime = prev.currentTime; } catch (e) {} }
        Object.keys(A).forEach(function (k2) { A[k2].muted = k2 !== ver; });
      }
      vbtns.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.baVer === ver ? 'true' : 'false'); });
      paintStatus();
      loadPeaks(ver);
      draw();
    }
    btn.addEventListener('click', function () { if (want) pause(); else play(); });
    vbtns.forEach(function (b) {
      if (!src[b.dataset.baVer]) b.disabled = true;
      b.addEventListener('click', function () { setVer(b.dataset.baVer); });
    });
    canvas.addEventListener('click', function (e) {
      if (!ver) return;
      ensure();
      var a = lead(), rect = canvas.getBoundingClientRect();
      var go = function () {
        if (!a.duration) return;
        var t = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width)) * a.duration;
        Object.keys(A).forEach(function (v) { try { A[v].currentTime = t; } catch (x) {} });
        card.classList.add('is-active'); draw();
      };
      if (a.duration) go(); else a.addEventListener('loadedmetadata', go, { once: true });
    });
    card.addEventListener('pointerenter', function () { if (ver) loadPeaks(ver); }, { once: true });
    if (!dry && !wet) { card.classList.add('is-empty'); btn.disabled = true; vbtns.forEach(function (b) { b.disabled = true; }); }
    vbtns.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.baVer === ver ? 'true' : 'false'); });
    paintStatus();
    if ('ResizeObserver' in window) new ResizeObserver(draw).observe(canvas); else window.addEventListener('resize', draw);
    draw();
  }

  function initHeading(root) {
    var el = root.querySelector('[data-ba-text]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!el || root.dataset.headAnim !== 'true' || reduce) return;
    var TITLE = el.textContent, chars = [], busy = false, inView = false, started = false;
    function build() {
      el.textContent = ''; chars = [];
      TITLE.split(' ').forEach(function (word, wi, arr) {
        var w = document.createElement('span'); w.className = 'ba__w';
        word.split('').forEach(function (ch) {
          var c = document.createElement('span'); c.className = 'ba__c'; c.textContent = ch;
          w.appendChild(c); chars.push({ el: c, ch: ch });
        });
        el.appendChild(w);
        if (wi < arr.length - 1) el.appendChild(document.createTextNode(' '));
      });
    }
    function run(decode, done) {
      if (busy) return; busy = true; build(); root.classList.remove('ba--prep');
      var plan = [], i, n = chars.length;
      if (decode) { var step = Math.min(38, 1000 / Math.max(n, 1)); for (i = 0; i < n; i++) plan[i] = chars[i].ch.trim() ? 240 + i * step + Math.random() * 140 : 0; }
      else { var pool = []; for (i = 0; i < n; i++) { plan[i] = 0; if (chars[i].ch.trim()) pool.push(i); } var hits = Math.min(pool.length, 2 + Math.floor(Math.random() * 2)); while (hits--) plan[pool.splice(Math.floor(Math.random() * pool.length), 1)[0]] = 200 + Math.random() * 140; }
      chars.forEach(function (c, idx) { if (plan[idx]) { c.el.textContent = noise(); c.el.classList.add('is-noise'); } });
      var t0 = performance.now();
      function frame(now) {
        var live = false;
        chars.forEach(function (c, idx) {
          var end = plan[idx]; if (!end || c.done) return;
          if (now - t0 < end) { live = true; if (now - (c.last || 0) > 55) { c.last = now; c.el.textContent = noise(); } }
          else { c.done = true; c.el.textContent = c.ch; c.el.classList.remove('is-noise'); }
        });
        if (live) requestAnimationFrame(frame); else { el.textContent = TITLE; busy = false; if (done) done(); }
      }
      requestAnimationFrame(frame);
    }
    function schedule() {
      setTimeout(function () {
        if (!document.body.contains(root)) return;
        if (!document.hidden && inView) run(false);
        schedule();
      }, 8000 + Math.random() * 5000);
    }
    root.classList.add('ba--prep');
    function start() { if (started) return; started = true; var go = function () { run(true, schedule); }; if (document.fonts && document.fonts.ready) document.fonts.ready.then(go); else go(); }
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { inView = en[0].isIntersecting; if (inView) start(); }, { threshold: 0.2 }).observe(root);
    else { inView = true; start(); }
  }

  function init(root) {
    if (!root || root.dataset.baReady) return;
    root.dataset.baReady = '1';
    [].forEach.call(root.querySelectorAll('[data-ba-card]'), function (c) { initCard(root, c); });
    initHeading(root);
  }
  function initAll(scope) { [].forEach.call((scope || document).querySelectorAll('[data-ba]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); }); else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function () { if (currentCard) { currentCard.pause(); currentCard = null; } });
})();
